import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import MainLayout from "../../layouts/MainLayout";
import { API_URL, STORAGE_URL } from "../../utils/constants";
import { useEffect, useState } from "react";
import { Col, Row, Modal, ModalBody } from "reactstrap";
import { FiClock, FiShare2 } from "react-icons/fi";
import { PRIMARY } from "../../utils/colors";
import { FaPhoneAlt } from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";
import DefaultButton from "../../components/Buttons/Default";
import DeletePropertyModal from "../../components/Modals/DeleteProperty";
import { generateKey, getOfficeName, nl2br, tField } from "../../utils/helpers";
import { MdDownloading } from "react-icons/md";
import { IoHeartOutline, IoHeartSharp, IoClose } from "react-icons/io5";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import {
  IoBedOutline, IoWaterOutline, IoExpandOutline,
  IoBuildOutline, IoCheckmarkCircleOutline, IoEyeOutline,
  IoCarOutline, IoPeopleOutline, IoFlashOutline, IoWifiOutline
} from "react-icons/io5";
import { BsLayersHalf } from "react-icons/bs";
import { MdBalcony } from "react-icons/md";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import moment from "moment";
import L from 'leaflet';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import './styles.css';
import BoostPropertyModal from "../../components/Modals/BoostProperty";
import { RiVerifiedBadgeFill } from "react-icons/ri";

delete L.Icon.Default.prototype._getIconUrl;
const pinIcon = new L.DivIcon({
  html: `<div style="width:26px;height:26px;background:#3e9a73;border-radius:50%;border:3px solid #fff;box-shadow:0 2px 10px rgba(0,0,0,0.3)"></div>`,
  iconSize: [26, 26],
  iconAnchor: [13, 13],
  className: ''
});

function PropertyPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { id } = useParams();
  const [propertyLoading, setPropertyLoading] = useState(true);
  const [property, setProperty] = useState(location.state?.property || null);
  const [deleteModalShown, setDeleteModalShown] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [pauseLoading, setPauseLoading] = useState(false);
  const [imageViewerOpen, setImageViewerOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [allMedia, setAllMedia] = useState([]);
  const [boostModalShown, setBoostModalShown] = useState(false);

  useEffect(() => {
    if (!property) {
      getProperty();
    } else {
      if (property.images.length > 0) {
        setSelectedImage(STORAGE_URL + property.images[0].image_path);
      } else if (property.videos.length > 0) {
        setSelectedImage(STORAGE_URL + property.videos[0].video_path);
      }
      setPropertyLoading(false);
      addView();
    }
  }, [id]);

  useEffect(() => {
    if (property) {
      const media = [
        ...(property.videos || []).map(v => ({ type: 'video', path: STORAGE_URL + v.video_path })),
        ...(property.images || []).map(img => ({ type: 'image', path: STORAGE_URL + img.image_path }))
      ];
      setAllMedia(media);
    }
  }, [property]);

  const getProperty = () => {
    fetch(API_URL + '/properties/property/' + id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
    .then(r => r.json())
    .then(data => {
      if (data.success) {
        setProperty(data.property);
        if (data.property.images.length > 0) {
          setSelectedImage(STORAGE_URL + data.property.images[0].image_path);
        } else if (data.property.videos.length > 0) {
          setSelectedImage(STORAGE_URL + data.property.videos[0].video_path);
        }
      }
      setPropertyLoading(false);
    });
  };

  const addView = () => {
    fetch(API_URL + '/properties/property/' + id + '/add-view', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    });
  };

  const openImageViewer = (mediaPath) => {
    const index = allMedia.findIndex(m => m.path === mediaPath);
    setCurrentImageIndex(index);
    setImageViewerOpen(true);
  };

  const nextImage = () => setCurrentImageIndex(p => (p + 1) % allMedia.length);
  const prevImage = () => setCurrentImageIndex(p => (p - 1 + allMedia.length) % allMedia.length);

  const pause = (status) => {
    setPauseLoading(true);
    fetch(API_URL + '/user/properties/' + status + '/' + property.id, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
    .then(r => r.json())
    .then(data => {
      if (data.success) {
        if (status === 'activate') toast.success('تم تفعيل الإعلان بنجاح');
        else if (status === 'pause') toast.success('تم ايقاف الإعلان بنجاح');
        getProperty();
      }
    })
    .catch(console.error)
    .finally(() => setPauseLoading(false));
  };

  const addToFavorites = () => {
    fetch(API_URL + '/user/favorites/store', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({ property_id: property.id })
    })
    .then(r => r.json())
    .then(data => { if (data.success) setProperty(data.property); })
    .catch(console.error);
  };

  const share = () => {
    if (navigator.share) {
      navigator.share({
        title: property?.title,
        text: 'قم بزيارة هذا العقار على موقع عقاراتي',
        url: 'https://aqaraty.ly/ar/property/' + property?.id
      }).catch(console.error);
    } else {
      alert('المشاركة غير متاحة على هذا المتصفح');
    }
  };

  const incrementCallsCount = () => {
    fetch(API_URL + '/properties/property/' + property.id + '/increment-calls-count', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    });
  };

  const incrementWhatsappCount = () => {
    fetch(API_URL + '/properties/property/' + property.id + '/increment-whatsapp-clicks-count', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    });
  };

  const generateWhatsappMessage = () =>
    `السلام عليكم%0Aأنا مهتم بهذا الإعلان:%0A https://aqaraty.ly/ar/property/${property?.id}`;

  const isFavorited = property?.favorites?.some(f => f.user_id === JSON.parse(localStorage.getItem('user'))?.id);
  const isOwner = Number(property?.user_id) === Number(JSON.parse(localStorage.getItem('user'))?.id);

  const stats = [
    { icon: <IoBedOutline size={20} />,    val: property?.bedrooms_count,  lbl: 'غرف' },
    { icon: <IoWaterOutline size={20} />,  val: property?.bathrooms_count, lbl: 'حمامات' },
    { icon: <IoExpandOutline size={20} />, val: property?.area_size,       lbl: 'م²' },
    { icon: <BsLayersHalf size={18} />,    val: property?.floor_number,    lbl: 'طابق' },
  ].filter(s => s.val !== null && s.val !== undefined);

  const features = [
    { key: 'is_furnished',         label: 'مفروش',         icon: <MdBalcony size={14} />,         show: !!property?.is_furnished },
    { key: 'for_families',         label: 'للعائلات',       icon: <IoPeopleOutline size={14} />,   show: !!property?.for_families },
    { key: 'has_parking',          label: 'موقف سيارة',    icon: <IoCarOutline size={14} />,      show: !!property?.has_parking },
    { key: 'electricity_included', label: 'كهرباء شاملة',  icon: <IoFlashOutline size={14} />,    show: !!property?.electricity_included },
    { key: 'water_included',       label: 'ماء شامل',      icon: <IoWaterOutline size={14} />,    show: !!property?.water_included },
    { key: 'internet_included',    label: 'إنترنت شامل',   icon: <IoWifiOutline size={14} />,     show: !!property?.internet_included },
  ].filter(f => f.show);

  const hasCoords = property?.latitude && property?.longitude;
  const mapFallbackQuery = property?.city ? tField(property.city, 'name') + ', Libya' : 'Tripoli, Libya';

  return (
    <MainLayout
      isTopBar
      screenTitle={t('property.title')}
      headerLeft={
        isFavorited
          ? <IoHeartSharp size={22} onClick={addToFavorites} className="cursor-pointer" color={PRIMARY} />
          : <IoHeartOutline size={22} onClick={addToFavorites} className="cursor-pointer" color={PRIMARY} />
      }
    >
      {propertyLoading ? (
        <div className="loader-container mt-4">
          <div className="loader"></div>
        </div>
      ) : (
        <div className="property-page">
          {/* ── MEDIA GALLERY ── */}
          <div className="property-gallery">
            <div className="property-gallery__main" onClick={() => selectedImage && openImageViewer(selectedImage)}>
              {selectedImage?.includes('video') ? (
                <video src={selectedImage} className="property-gallery__main-media" controls />
              ) : (
                <img src={selectedImage || require('../../assets/images/default-office.png')} alt="" className="property-gallery__main-media" />
              )}
              {allMedia.length > 1 && (
                <span className="property-gallery__counter">
                  <IoExpandOutline size={14} /> {allMedia.length} صورة
                </span>
              )}
            </div>

            {allMedia.length > 1 && (
              <div className="property-gallery__thumbs">
                {allMedia.map((m, i) => (
                  <div
                    key={i}
                    className={'property-gallery__thumb' + (selectedImage === m.path ? ' active' : '')}
                    onClick={() => setSelectedImage(m.path)}
                  >
                    {m.type === 'video' ? (
                      <video src={m.path} className="property-gallery__thumb-media" />
                    ) : (
                      <img src={m.path} alt="" className="property-gallery__thumb-media" />
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* ── CONTENT ── */}
          <div className="property-content">

            {/* Title + price + meta */}
            <div className="property-header">
              <div className="property-header__top">
                <h1 className="property-header__title">{tField(property, 'title')}</h1>
                <button className="property-header__share" onClick={share}>
                  <FiShare2 size={18} />
                </button>
              </div>

              <div className="property-header__meta">
                <span className="property-header__meta-item">
                  <FiClock size={13} />
                  {property?.created_at && moment(property.created_at).fromNow().replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d))}
                </span>
                <span className="property-header__meta-item">
                  <IoEyeOutline size={13} /> {property?.views || 0}
                </span>
              </div>

              {property?.price && (
                <div className="property-header__price">
                  {property.price} <span>د.ل</span>
                </div>
              )}
            </div>

            {/* ── STATS ── */}
            {stats.length > 0 && (
              <div className="property-stats">
                {stats.map((s, i) => (
                  <div className="property-stat" key={i}>
                    {s.icon}
                    <span className="property-stat__val">{s.val}</span>
                    <span className="property-stat__lbl">{s.lbl}</span>
                  </div>
                ))}
              </div>
            )}

            {/* ── DESCRIPTION ── */}
            {property?.description_ar && (
              <div className="property-section">
                <h3 className="property-section__title">
                  <IoBuildOutline size={18} /> الوصف
                </h3>
                <p className="property-section__body" dangerouslySetInnerHTML={{ __html: nl2br(property.description_ar) }} />
              </div>
            )}

            {/* ── FEATURES ── */}
            {features.length > 0 && (
              <div className="property-section">
                <h3 className="property-section__title">
                  <IoCheckmarkCircleOutline size={18} /> المميزات
                </h3>
                <div className="property-features">
                  {features.map(f => (
                    <span key={f.key} className="property-feature">
                      {f.icon} {f.label}
                    </span>
                  ))}
                </div>
              </div>
            )}

            {/* ── OFFICE / AGENT ── */}
            {property?.user?.is_office && (
              <div className="property-section">
                <h3 className="property-section__title">المكتب العقاري</h3>
                <Link to={'/office/' + property.user.id} className="property-agent">
                  <img
                    src={property.user.profile_picture_path
                      ? STORAGE_URL + property.user.profile_picture_path
                      : require('../../assets/images/default-office.png')}
                    alt="Office"
                    className="property-agent__img"
                  />
                  <div className="property-agent__info">
                    <span className="property-agent__name">
                      {getOfficeName(property.user)}
                      {property.user.is_verified && <RiVerifiedBadgeFill size={16} className="ms-1 text-primary" />}
                    </span>
                    <span className="property-agent__sub">مكتب عقاري</span>
                  </div>
                  <IoChevronBack size={18} className="text-muted" />
                </Link>
              </div>
            )}

            {/* ── MAP ── */}
            <div className="property-section">
              <h3 className="property-section__title">الموقع</h3>
              <div className="property-map">
                {hasCoords ? (
                  <MapContainer
                    center={[parseFloat(property.latitude), parseFloat(property.longitude)]}
                    zoom={15}
                    style={{ width: '100%', height: '220px' }}
                    zoomControl={false}
                    scrollWheelZoom={false}
                    dragging={false}
                    doubleClickZoom={false}
                  >
                    <TileLayer
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                    />
                    <Marker
                      position={[parseFloat(property.latitude), parseFloat(property.longitude)]}
                      icon={pinIcon}
                    />
                  </MapContainer>
                ) : (
                  <iframe
                    title="property-map"
                    src={`https://maps.google.com/maps?q=${encodeURIComponent(mapFallbackQuery)}&output=embed&hl=ar`}
                    frameBorder="0"
                    style={{ width: '100%', height: '220px', border: 'none' }}
                    loading="lazy"
                    allowFullScreen
                  />
                )}
              </div>
            </div>

            {/* ── OWNER CONTROLS ── */}
            {isOwner && (
              <div className="property-section">
                <h3 className="property-section__title">إدارة الإعلان</h3>
                <Row className="g-2">
                  <Col xs="6">
                    <DefaultButton color="primary" block onClick={() => navigate('/my_properties/create', { state: { property } })}>
                      تعديل
                    </DefaultButton>
                  </Col>
                  <Col xs="6">
                    {property?.status === 'paused' || property?.status === 'archived' ? (
                      <DefaultButton color="success" block outline loading={pauseLoading} onClick={() => pause('activate')} disabled={pauseLoading}>
                        تشغيل
                      </DefaultButton>
                    ) : (
                      <DefaultButton color="danger" block outline loading={pauseLoading} onClick={() => pause('pause')} disabled={pauseLoading}>
                        إيقاف مؤقت
                      </DefaultButton>
                    )}
                  </Col>
                  <Col xs="6">
                    <DefaultButton color="warning" block onClick={() => setBoostModalShown(true)}>
                      تثبيت
                    </DefaultButton>
                  </Col>
                  <Col xs="6">
                    <DefaultButton color="danger" block onClick={() => setDeleteModalShown(true)}>
                      حذف
                    </DefaultButton>
                  </Col>
                </Row>
              </div>
            )}

            <div style={{ height: property?.phone_number ? 80 : 24 }} />
          </div>
        </div>
      )}

      <DeletePropertyModal
        isOpen={deleteModalShown}
        toggle={() => setDeleteModalShown(!deleteModalShown)}
        propertyId={property?.id}
        onSuccess={() => navigate('/my_properties?p=' + generateKey())}
      />
      <BoostPropertyModal
        isOpen={boostModalShown}
        toggle={() => setBoostModalShown(!boostModalShown)}
        propertyId={property?.id}
        onSuccess={() => navigate('/my_properties?p=' + generateKey())}
      />

      {/* ── FIXED CTA ── */}
      {property?.phone_number && (
        <div className="bottom-fixed-cta">
          <a
            href={`tel:${property?.user?.country_code}${property?.phone_number}`}
            className="property-cta-call"
            onClick={incrementCallsCount}
          >
            <FaPhoneAlt size={18} />
          </a>
          <a
            href={`https://wa.me/${property?.user?.country_code}${property?.phone_number}?text=${generateWhatsappMessage()}`}
            target="_blank"
            rel="noreferrer"
            className="property-cta-whatsapp btn-property-whatsapp"
            onClick={incrementWhatsappCount}
          >
            <IoLogoWhatsapp size={22} />
            {t('property.whatsapp')}
          </a>
        </div>
      )}

      {/* ── IMAGE VIEWER ── */}
      <Modal isOpen={imageViewerOpen} toggle={() => setImageViewerOpen(false)} size="lg" fullscreen centered>
        <ModalBody className="p-0 position-relative" style={{ backgroundColor: '#000' }}>
          <div className="position-absolute top-0 end-0 m-3 cursor-pointer" style={{ zIndex: 1000 }} onClick={() => setImageViewerOpen(false)}>
            <IoClose size={34} color="#fff" />
          </div>
          <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
            {allMedia[currentImageIndex]?.type === 'video' ? (
              <video src={allMedia[currentImageIndex]?.path} controls autoPlay style={{ maxWidth: '100%', maxHeight: '80vh' }} />
            ) : (
              <img src={allMedia[currentImageIndex]?.path} alt="" style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }} />
            )}
          </div>
          {allMedia.length > 1 && (
            <>
              <div className="position-absolute top-50 end-0 translate-middle-y cursor-pointer p-3" onClick={prevImage} style={{ zIndex: 1000 }}>
                <IoChevronBack size={40} color="#fff" />
              </div>
              <div className="position-absolute top-50 start-0 translate-middle-y cursor-pointer p-3" onClick={nextImage} style={{ zIndex: 1000 }}>
                <IoChevronForward size={40} color="#fff" />
              </div>
            </>
          )}
          <div className="position-absolute bottom-0 w-100 text-center text-white p-2" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            {currentImageIndex + 1} / {allMedia.length}
          </div>
        </ModalBody>
      </Modal>
    </MainLayout>
  );
}

export default PropertyPage;
